



































































import { Component, namespace, mixins, Watch } from 'nuxt-property-decorator'
import { mdiClockOutline, mdiEmailOutline, mdiPhone } from '@mdi/js'
import { NuxtAppOptions } from '@nuxt/types'
import { STORES_API } from '~/assets/config/api-path'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import MixinGeneral from '~/assets/mixins/general'
import { STORES_PATH } from '~/assets/config/path'
import { IImageVariants } from '~/assets/interfaces/images'
import { filterPhone } from '~/assets/filters/phone'
import { filterEmail } from '~/assets/filters/email'
import { Map, ObjectManager, Placemark } from '~/assets/shims/ymaps'
import { IStyle } from '~/assets/interfaces/classes'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentImage from '~/components/images/image.vue'

const pageStore = namespace('page')
const siteStore = namespace('site')
@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentNavigationBreadcrumbs,
    ComponentPageContent,
    ComponentTypographyH1,
    ComponentImage,
    ComponentIcon,
  },
  filters: {
    filterPhone,
    filterEmail,
  },
})
export default class pageContactsIndex extends mixins(MixinGeneral) {
  private async asyncData({
    $axios,
    route,
    error,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
  }) {
    try {
      const response = await $axios.$get(
        STORES_API + '/' + route.params._id + '/'
      )

      return response
    } catch (err) {
      error({ statusCode: 404, message: 'Post not found' })
    }
  }

  @siteStore.Getter('getApiKeyYandexMap') private getApiKeyYandexMap!:
    | string
    | null

  private image: IImageVariants | null = null
  private address = ''
  private phone = ''
  private time = ''
  private email = ''
  private title = ''
  private lon = 0
  private lat = 0

  private icons = {
    mdiClockOutline,
    mdiPhone,
    mdiEmailOutline,
  }

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  @Watch('ymapsScriptLoaded')
  private OnYmapsScriptLoadedChange(val: boolean) {
    if (val) {
      this.ymapsReady()
    }
  }

  private mounted() {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src =
      'https://api-maps.yandex.ru/2.1/?apikey=' +
      this.getApiKeyYandexMap +
      '&lang=ru_RU&onload=pageStoreItemYmapsInit'

    document.getElementsByTagName('head')[0].appendChild(script)
    window.pageStoreItemYmapsInit = this.pageStoreItemYmapsInit
  }

  private pageStoreItemYmapsInit() {
    this.ymapsScriptLoaded = true
  }

  private isMapLoaded = false

  private YandexMap: Map | null = null

  private get classMbGutter() {
    return {
      [this.styleSpacer.mbGutter2]: !this.$device.isMobileOrTablet,
      [this.styleSpacer.mbGutter]: this.$device.isMobileOrTablet,
    }
  }

  private styleSpacer!: IStyle

  private ymapsDestroy() {
    if (this.YandexMap) {
      this.YandexMap.destroy()
      this.YandexMap = null
    }
    if (this.$refs.map) {
      ;(this.$refs.map as HTMLElement).innerHTML = ''
    }
  }

  private ymapsScriptLoaded = false

  private ymapsReady() {
    if (this.ymapsScriptLoaded) {
      ymaps.ready(async () => {
        if (this.YandexMap) {
          this.ymapsDestroy()
        }
        this.YandexMap = new ymaps.Map('map', {
          controls: ['zoomControl', 'geolocationControl'],
          center: [55.76, 37.64],
          zoom: 7,
        })
        this.isMapLoaded = true

        await this.ymapsGeoObjectsInsert()
      })
    }
  }

  private clusterer: ObjectManager | null = null

  private async ymapsGeoObjectsInsert() {
    if (this.YandexMap) {
      this.YandexMap.geoObjects.removeAll()
      this.clusterer = new ymaps.Clusterer()

      const geoObjects: Placemark[] = [
        new ymaps.Placemark([this.lon, this.lat]),
      ]

      if (this.clusterer) {
        this.clusterer.add(geoObjects)
        this.YandexMap.geoObjects.add(this.clusterer) // eslint-disable-line
        const bounds: number[][] | null = this.YandexMap.geoObjects.getBounds()

        if (bounds !== null) {
          await this.YandexMap.setBounds(bounds, {
            checkZoomRange: true,
            zoomMargin: [64, 128],
          })

          if (this.YandexMap.getZoom() > 16) {
            await this.YandexMap.setZoom(16)
          }
        }
      }
    }
  }

  private ymapsPlaceMarkInsert(address: {
    lon: number
    lat: number
  }): Placemark | undefined {
    if (this.YandexMap) {
      return new ymaps.Placemark([address.lon, address.lat])
    }
  }

  private created(): void {
    this.setMeta({
      title: this.title + ' - ' + this.address,
      h1: this.title,
    })

    this.setBreadcrumbs([
      {
        title: 'Магазины',
        url: STORES_PATH,
      },
    ])
  }
}
